import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS, SITE } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  const isHome = location.pathname === '/';
  const solid = scrolled || !isHome || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-[68px] md:h-[74px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 group" aria-label="黑料百科首页">
          <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl font-heading">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl text-foreground-950 tracking-wide">
              {SITE.name}
            </span>
            <span className="hidden sm:block text-[10px] tracking-[0.28em] text-primary-500 mt-1">
              {SITE.englishName}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {NAV_LINKS.map((item) => {
            const to = item.hash ? `${item.to}#${item.hash}` : item.to;
            const active =
              item.to === location.pathname && (!item.hash || `#${item.hash}` === location.hash);
            return (
              <Link
                key={item.label}
                to={to}
                className={`px-4 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <span className="text-xs text-foreground-600 whitespace-nowrap hidden lg:inline">
            {SITE.since}
          </span>
          <Link
            to="/archive"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            进入档案库
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-900 cursor-pointer"
        >
          <i className={open ? 'ri-close-line text-lg' : 'ri-menu-2-line text-lg'}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 flex flex-col gap-1">
          {NAV_LINKS.map((item) => (
            <Link
              key={item.label}
              to={item.hash ? `${item.to}#${item.hash}` : item.to}
              className="px-4 py-3 rounded-md text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer"
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/archive"
            className="mt-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center cursor-pointer"
          >
            进入档案库
          </Link>
        </div>
      )}
    </header>
  );
}